/**
 * 브랜드 허브 고르개의 값 — 목록 정렬 · 상세의 면.
 *
 * 허브 화면과 「질문 → 화면」 조건표(`ask-screens`)가 함께 읽는 한 벌이다.
 * 🔑 면의 차례는 **무엇을 내놓았나 → 누가 말했나** 순이다 — 글·광고·상품(브랜드가 낸 것)이 먼저 서고
 *   크리에이터·캠페인(그것을 누가·어떤 묶음으로 다뤘나)이 뒤따른다.
 */

/** 목록 정렬의 아는 값 — 세션에 저장된 글자를 여기에 맞춰 거른다 */
export const BRAND_HUB_LIST_ORDERS = ['mentions', 'reach'] as const;
export type BrandHubListOrder = (typeof BRAND_HUB_LIST_ORDERS)[number];

/** 목록 정렬 고르개 — 브랜드 랭킹이 받는 두 가지 그대로(`orderBy`) */
export const BRAND_HUB_LIST_ORDER_OPTIONS: { key: BrandHubListOrder; label: string }[] = [
  { key: 'mentions', label: '언급 많은 순' },
  { key: 'reach', label: '도달 많은 순' },
];

export type BrandFace = 'overview' | 'content' | 'ads' | 'products' | 'creators' | 'events';

/** 상세의 면 — 상세 화면과 공유 페이지가 **같은 탭 줄**을 쓴다 */
export const BRAND_HUB_FACES: { key: BrandFace; label: string }[] = [
  { key: 'overview', label: '개요' },
  { key: 'content', label: '소셜포스팅' },
  { key: 'ads', label: '광고' },
  { key: 'products', label: '상품' },
  { key: 'creators', label: '크리에이터' },
  { key: 'events', label: '캠페인' },
];
